import React from 'react'
import CommonBox from '../CommonBox'
import GifImagesSection from '../GifImagesSection'
import SingleNoticeCustomerSection from '../SingleCoustomerSection'

const SingleCustomer = () => {
  return (
    <>
      <section className='single-customer'>
        <CommonBox heading=" 고객센터 " englishHeading=" customer center" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
          <SingleNoticeCustomerSection/>
        </CommonBox>
      </section>
      <section className='gif-section flex lg:hidden items-center justify-center'>
        <GifImagesSection />
      </section>
    </>
  )
}
export default SingleCustomer